import useStoredEventMarkers from './useStoredEventMarkers';
import { DIVERGENCE_EVENT_TYPES, toDivergenceLibraryEvent } from '../rsiDivergence';

// RSI and DSS divergences at confirmed daily cycle pivots (DWLF-338), stored nightly by the jobs.
export default function useBackendDivergenceEvents(symbol, { enabled = true } = {}) {
  return useStoredEventMarkers(enabled ? symbol : null, {
    eventTypes: DIVERGENCE_EVENT_TYPES, toLibraryEvent: toDivergenceLibraryEvent, label: 'divergence',
  });
}
